import { ChevronsLeft, ChevronsRight } from 'lucide-react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useCallback } from 'react'

import { Button } from '@/components/button/button'

interface Props {
  totalPages: number
  currentPage: number
  onPageChange: (page: number) => void
}

export const Pagination: React.FC<Props> = ({ totalPages, currentPage, onPageChange }) => {
  const handleFirstClick = useCallback(() => {
    onPageChange(0)
  }, [onPageChange])

  const handlePreviousClick = useCallback(() => {
    if (currentPage <= 0) {
      return
    }

    onPageChange(currentPage - 1)
  }, [onPageChange, currentPage])

  const handleNextClick = useCallback(() => {
    if (currentPage >= totalPages - 1) {
      return
    }

    onPageChange(currentPage + 1)
  }, [onPageChange, currentPage, totalPages])

  const handleLastClick = useCallback(() => {
    onPageChange(totalPages - 1)
  }, [onPageChange, totalPages])

  return (
    <div className="flex items-center justify-end gap-4">
      <div className="text-xs font-medium">
        Page {currentPage + 1} of {totalPages}
      </div>

      <div className="flex gap-2">
        <Button
          className="h-8 w-8 p-0"
          variant="outline"
          size="sm"
          disabled={currentPage <= 0}
          onClick={handleFirstClick}
        >
          <ChevronsLeft size={16} />
        </Button>

        <Button
          className="h-8 w-8 p-0"
          variant="outline"
          size="sm"
          disabled={currentPage <= 0}
          onClick={handlePreviousClick}
        >
          <ChevronLeft size={14} />
        </Button>

        <Button
          className="h-8 w-8 p-0"
          variant="outline"
          size="sm"
          disabled={currentPage >= totalPages - 1}
          onClick={handleNextClick}
        >
          <ChevronRight size={14} />
        </Button>

        <Button
          className="h-8 w-8 p-0"
          variant="outline"
          size="sm"
          disabled={currentPage >= totalPages - 1}
          onClick={handleLastClick}
        >
          <ChevronsRight size={16} />
        </Button>
      </div>
    </div>
  )
}
